export class ThirdPartiesLib {
    chainId;
    certificates;
    constructor(chainId, certificates) {
        this.chainId = chainId;
        this.certificates = certificates;
    }
    openSea = async (tokenId) => openSea({
        chainId: this.chainId,
        contractAddress: this.certificates,
        tokenId: tokenId,
    });
    polygonScan = async (tokenId) => polygonScan({
        chainId: this.chainId,
        contractAddress: this.certificates,
        tokenId: tokenId,
    });
}
export const blockchainLinks = {
    openSea: {
        80002: async (contractAddress, token) => Promise.resolve(`https://testnets.opensea.io/assets/amoy/${contractAddress}/${token}`),
        137: async (contractAddress, token) => Promise.resolve(`https://opensea.io/assets/matic/${contractAddress}/${token}`),
    },
    polygonScan: {
        80002: async (address, token) => Promise.resolve(`https://amoy.polygonscan.com/token/${address}?a=${token}`),
        137: async (address, token) => Promise.resolve(`https://polygonscan.com/token/${address}?a=${token}`),
    },
};
const openSea = async (params) => templateByChainId(blockchainLinks.openSea, params);
const polygonScan = async (params) => templateByChainId(blockchainLinks.polygonScan, params);
const templateByChainId = async (templates, params) => Promise.resolve(templates[params.chainId])
    .then(async (template) => (template ? Promise.resolve(template) : Promise.reject(params.chainId)))
    .then(async (template) => template(params.contractAddress, params.tokenId));
//# sourceMappingURL=third-parties.js.map